export const ROUTES = {
	ownerDashboard: 'owner/dashboard',
	ownerPlayControllers: 'ownerplaycontrollers',
	ownerTournaments: 'owner/tournaments',
	ownerCreateTournament: 'owner/create-tournament',
	ownerGeofences: 'owner/geofences',
	// Mobile
	mobilePlayControllers: 'mobileplaycontrollers',
	mobileDrive: 'mobile-drive',
	// AI Agents
	aiAgents: 'owner/ai-agents'
};
